import React from 'react';
import PropTypes from 'prop-types';

/** renders a label at the top of a cards list */
const CardsLabel = ({
  children,
  labelPosition
}) => {
  return (
    <h2 className={`cards-label cards-label-${labelPosition}`}>
      {children}
    </h2>
  );
};

CardsLabel.propTypes = {
  children: PropTypes.node,
  labelPosition: PropTypes.string
};

CardsLabel.defaultProps = {
  labelPosition: 'center'
}

export default CardsLabel;
